import Button from "../Button";
import useNotice from "../../hooks/useNotice";
import { regMobileNo } from "../../api/login";
import { useSendCodeEmail } from "../../api/userPass";
import { useEffect, useState } from "react";
import { useAsyncEffect, useCountDown } from "ahooks";
import CheckBox from "../../mall-7/src/components/CheckBox";
import Modal from "../Modal";
import { getI18n, useTranslation } from "react-i18next";
import cookies from "../../utils/cookies";
import { useNavigateTo } from "../../hooks/useNavigateTo";
import { useGetAgentIdByDomainName } from "../../api/agent";

export default function RegisterForm({ children }) {
  const { t } = useTranslation();
  const { loading, query, reg, inputHandle } = regMobileNo();
  const [targetDate, setTargetDate] = useState();
  const [agentInfo, setAgentInfo] = useState({});
  const [regAgentVisible, setRegAgentVisible] = useState(false);
  const [priAgentVisible, setPriAgentVisible] = useState(false);
  const [countdown] = useCountDown({ targetDate });
  const { sendCode } = useSendCodeEmail();
  const navigateTo = useNavigateTo();
  const notice = useNotice();
  const { getAgent } = useGetAgentIdByDomainName();
  const lang = getI18n().language;

  /**
   * 注册
   */
  const regHandle = () => {
    if (!query.account) {
      return notice.warn(
        `${t("请输入")}${
          agentInfo.isAllowMobileno === "1" ? t("手机号") + "/" : ""
        }${t("邮箱")}`
      );
    }

    if (!query.verifyCode) {
      return notice.warn(`${t("请输入")}${t("验证码")}`);
    }

    if (!query.pwd) {
      return notice.warn(`${t("请输入")}${t("密码")}`);
    }

    if (query.confirmPwd !== query.pwd) {
      return notice.warn(t("两次输入的密码不相同!"));
    }

    if (!query.argumentsCheck) {
      return notice.warn(t("您未勾选同意我们的相关注册协议!"));
    }

    reg();
  };

  /**
   * 获取验证码
   * @returns {Promise<void>}
   */
  const getVerCode = async () => {
    if (!query.account) {
      return notice.warn(t("账号或者密码不能为空!"));
    }

    let data = await sendCode({
      email: query.account,
    });

    if (data) {
      notice.success("短信已发送");
      setTargetDate(Date.now() + 60000);
    }
  };

  const argumentsCheckHandle = () => {
    inputHandle({ target: { value: !query.argumentsCheck } }, "argumentsCheck");
  };

  const getDomainInfo = async () => {
    let { data, error } = await getAgent();

    if (data) {
      setAgentInfo(data);
    }
  };

  useEffect(() => {
    getDomainInfo();
    // setAgentInfo(cookies.get('agentInfo'));
  }, []);

  return (
    <>
      {children ? (
        children({
          t,
          query,
          loading,
          navigateTo,
          countdown,
          setAgentInfo,
          regAgentVisible,
          setRegAgentVisible,
          priAgentVisible,
          setPriAgentVisible,
          inputHandle,
          regHandle,
          argumentsCheckHandle,
          getVerCode,
        })
      ) : (
        <>
          <div className={"mb-[15px]"}>
            <label className="text-[14px] hidden mb-[5px] md:block inp-must">
              {agentInfo.isAllowMobileno === "1" && t("手机号") + "/"}
              {t("邮箱")}
            </label>
            <input
              type="text"
              placeholder={`${t("请输入")}${
                agentInfo.isAllowMobileno === "1" ? t("手机号") + "/" : ""
              }${t("邮箱")}`}
              value={query.account}
              onChange={(e) => inputHandle(e, "account")}
              className="p-[15px] container md:border border-bottom-1px mdmax:rounded-none border-[#d4d4d4] text-[15px]"
            />
          </div>

          <div className="mb-[15px]">
            <label className="inp-must text-[14px] hidden mb-[5px] md:block">
              {t("验证码")}
            </label>
            <div className="flex">
              <input
                type="text"
                placeholder={`${t("请输入")}${t("验证码")}`}
                value={query.verifyCode}
                onChange={(e) => inputHandle(e, "verifyCode")}
                className="p-[15px] container md:border border-bottom-1px mdmax:rounded-none border-[#d4d4d4] text-[15px] mr-4"
              />
              <Button
                onClick={getVerCode}
                disabled={countdown > 0}
                className={
                  "rounded-none bg-[#333] text-white w-[180px] text-[14px]"
                }
              >
                {countdown > 0
                  ? `${Math.round(countdown / 1000)}s`
                  : t("获取验证码")}
              </Button>
            </div>
          </div>

          <div className="mb-[15px]">
            <label className="inp-must text-[14px] hidden mb-[5px] md:block">
              {t("密码")}
            </label>
            <input
              type="password"
              placeholder={`${t("请输入")}${t("密码")}`}
              value={query.pwd}
              onChange={(e) => inputHandle(e, "pwd")}
              className="p-[15px] container md:border border-bottom-1px mdmax:rounded-none border-[#d4d4d4] text-[15px]"
            />
          </div>

          <div className="mb-[10px]">
            <label className="inp-must text-[14px] hidden mb-[5px] md:block">
              {t("重复密码")}
            </label>
            <input
              type="password"
              placeholder={`${t("请输入")}${t("重复密码")}`}
              value={query.confirmPwd}
              onChange={(e) => inputHandle(e, "confirmPwd")}
              className="p-[15px] container md:border border-bottom-1px mdmax:rounded-none border-[#d4d4d4] text-[15px]"
            />
          </div>
          <div className="flex items-center">
            <CheckBox
              className="flex-none"
              onClick={argumentsCheckHandle}
              checked={query.argumentsCheck}
            />
            <p className="text-[14px] ml-[10px] mt-[2px]">
              {t("我已阅读并同意遵守")}
              <a
                onClick={() => setRegAgentVisible(true)}
                className="link mx-[4px]"
              >
                {t("注册协议")}
              </a>
              {t("和")}
              <a
                onClick={() => setPriAgentVisible(true)}
                className="link mx-[4px]"
              >
                {t("隐私条款")}
              </a>
            </p>
          </div>

          <Button
            onClick={regHandle}
            loading={loading}
            className="rounded-none mdmax:rounded-full container text-[14px]
                         py-[12px] bg-[#333] text-white mb-[5px] mt-[60px]"
          >
            {t("注册")}
          </Button>
          {/*<div className={'justify-between hidden md:flex'}>*/}
          {/*  <a className={'link text-[#999]'}>忘记密码?</a>*/}
          {/*  <a className={'link text-[#999]'}>注册</a>*/}
          {/*</div>*/}
        </>
      )}
      <Modal
        title="注册协议"
        top="0"
        mt={"5vh"}
        onClose={setRegAgentVisible}
        visible={regAgentVisible}
        footer={
          <div className="text-center">
            <Button
              onClick={() => setRegAgentVisible(false)}
              className="border border-[#ddd] rounded-[5px] bg-white px-[34px] py-[8px]"
            >
              好的
            </Button>
          </div>
        }
      >
        {agentInfo && (
          <div className="overflow-y-scroll h-[70vh] mdmax:px-[15px]">
            <div
              className="overflow-y-scroll"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "en"
                    ? agentInfo.enRegProtocal
                    : agentInfo.regProtocal,
              }}
            />
          </div>
        )}

        <div className="text-center pt-[5px] pb-[12px] md:hidden">
          <Button
            onClick={() => setRegAgentVisible(false)}
            className="border border-[#ddd] rounded-[5px] bg-white px-[34px] py-[8px]"
          >
            好的
          </Button>
        </div>
      </Modal>

      <Modal
        title="隐私协议"
        top="0"
        mt={"5vh"}
        onClose={setPriAgentVisible}
        visible={priAgentVisible}
        footer={
          <div className="text-center">
            <Button
              onClick={() => setPriAgentVisible(false)}
              className="border border-[#ddd] rounded-[5px] bg-white px-[34px] py-[8px]"
            >
              好的
            </Button>
          </div>
        }
      >
        {agentInfo && (
          <div className="overflow-y-scroll h-[70vh] mdmax:px-[15px]">
            <div
              className="overflow-y-scroll"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "en"
                    ? agentInfo.enPriProtocal
                    : agentInfo.priProtocal,
              }}
            />
          </div>
        )}
        <div className="text-center pt-[5px] pb-[12px] md:hidden">
          <Button
            onClick={() => setPriAgentVisible(false)}
            className="border border-[#ddd] rounded-[5px] bg-white px-[34px] py-[8px]"
          >
            好的
          </Button>
        </div>
      </Modal>
    </>
  );
}
